<template>
  <main class="min-h-screen w-full bg-gray-100 p-4">
    <div class="w-full max-w-full mx-auto space-y-4">
      <!-- PAGE HEADER -->
      <div class="sticky top-0 z-20 flex items-center justify-between mb-3 bg-gray-100 py-3">
        <h1 class="text-2xl font-semibold text-gray-800">
          System Advisories Posts
        </h1>
        <button @click="openCreateModal"
          class="bg-orange-500 text-white font-medium px-3 py-1.5 rounded hover:bg-orange-600 transition">
          + Create Post
        </button>
      </div>

      <!-- POSTS LIST (separate component) -->
      <PostLists :posts="passSectionItemPost" media-width="25%" media-height="20%" @edit="openEditModal" />
    </div>

    <!-- CREATE / EDIT POST MODAL -->
    <CreatePostModal :show="showModal" :postToEdit="postBeingEdited" @close="closeModal"
      @postCreated="$emit('refresh')" />
  </main>
</template>

<script>
import { ref } from "vue";
import CreatePostModal from "./Modals/CreatePostModal.vue";
import PostLists from "./Posts/PostLists.vue";
export default {
  components: {
    CreatePostModal,
    PostLists,
  },
  props: {
    passSectionItemPost: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const showModal = ref(false);
    const postBeingEdited = ref(null);

    const openCreateModal = () => {
      postBeingEdited.value = null;
      showModal.value = true;
    };

    const openEditModal = (post) => {
      postBeingEdited.value = post;
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      postBeingEdited.value = null;
    };

    return {
      showModal,
      postBeingEdited,
      openCreateModal,
      openEditModal,
      closeModal,
    };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
